import { createContext, useContext, useEffect, useState } from 'react';
import { toRgbChannels } from '@playerelite/ui';
import { VENDOR, VENDORS } from '..';

type Context = {
  primary: string;
  secondary: string;
};

export const ColorContext = createContext<Context>({
  primary: '',
  secondary: '',
});

export function useColors() {
  return useContext(ColorContext);
}

export function AppColorsProvider({ children }: { children: React.ReactNode }) {
  const [colors, setColors] = useState<Context>({
    primary: '',
    secondary: '',
  });

  const assignColors = (primary: string, secondary: string) => {
    // Tailwind reads these as `rgb(var(--color-primary) / <alpha>)`, so they must be channels.
    document.documentElement.style.setProperty('--color-primary', toRgbChannels(primary));
    document.documentElement.style.setProperty('--color-secondary', toRgbChannels(secondary));
    setColors({ primary, secondary });
  };

  const fetchColors = async () => {
    if (VENDOR === VENDORS.PE || VENDOR === VENDORS.USA) {
      const primary = '#cdac3d';
      const secondary = '#343a40';
      assignColors(primary, secondary);
    }

    if (VENDOR === VENDORS.ODYSSEY) {
      const primary = '#055acd';
      const secondary = '#ffffff';
      assignColors(primary, secondary);
    }
  };

  useEffect(() => {
    fetchColors();
  }, []);

  const value: Context = colors;

  return (
    <ColorContext.Provider value={value}>{children}</ColorContext.Provider>
  );
}
